import axios from 'axios'
import { message } from '@/utils/resetMessage'; // 自定义重置 message
import { getToken, removeProjectLocalStorage } from './auth'
import router from '../router'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  config.headers['NewStartToken'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})
let abc = this;
// respone拦截器
service.interceptors.response.use(
  response => {
    // code 非 20000是抛错 可结合自己业务进行修改
    const res = response.data
    if (res.code == 20000) {
      return response
    } else {
      if (res.code === 50001 || res.code === 50002) {
        message.error('用户认证失败，请重新登录')
        removeProjectLocalStorage();
        router.push({ name: 'Login', query: { redirect: router.currentRoute.fullPath } })
      } else if (res.code === 50003) {
        message.error('登录过期，请重新登录')
        removeProjectLocalStorage();
        router.push({ name: 'Login', query: { redirect: router.currentRoute.fullPath } })
      } else if (res.code === 50005) {
        message.error('该账号在另一台设备上登录，您被强制下线，请您重新登陆')
        removeProjectLocalStorage();
        router.push({ name: 'Login', query: { redirect: router.currentRoute.fullPath } })
      } else {
        message.error(res.message)
      }
      return Promise.reject('error')
    }
  },
  error => {
    if (error.message === 'Network Error') {
      message.error("网络错误，请检查您的网络或待会儿重试")
      // window.location.href = process.env.BASE_URL + '#/network-error'
    } else {
      message.error(error.message)
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js